import { Record, RecordOf } from 'immutable';



export type SignInWitOtpRequest = RecordOf<SignInWitOtpRequestProperties>;


export interface SignInWitOtpRequestProperties {
  username: string;
  password: string;
  rememberUsername: boolean;
  otp: string;
  skip2fvSetUp: boolean;
  isEncoded: boolean;
}


export class SignInWitOtpRequestFactory {
  static readonly create = Record<SignInWitOtpRequestProperties>({
    username: null,
    password: null,
    rememberUsername: false,
    otp: null,
    skip2fvSetUp: false,
    isEncoded: false
  });
}
